import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";

import { format } from "date-fns";

import MaintenanceFilter from "../../../../components/FilterBox/MaintenanceFilter/MaintenanceFilter";
import MaintenanceTable from "../../../../components/Tables/MaintenanceTable";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { FiMenu } from "react-icons/fi";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { Loader } from "../../../../components/Loader/Loader";
import {
  PartyVsItem,
  PartyVsItemFun,
  StoreFilters,
} from "../../../../Redux/Slice/Maintenance/MaintenanceSlice";
import MaintenanceParentChild from "../../../../components/Tables/MaintenanceParentChild";
import { useTheme } from "../../../../Themecontext/Themecontext";
import MaintenanceCelender from "../../../../components/Calendar/MaintenanceCelender";
import Calendar from "react-calendar";

export const PartyItemAnalysis = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StoreFiltersdata, PartyVsItemdata } = useSelector(
    (state) => state.MaintenanceSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  useEffect(() => {
    console.log("API Called");
  }, [startDate, endDate]);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [activeTable, setActiveTable] = useState("PARTYWISE");

  const accountNameList =
    StoreFiltersdata?.InwardAc?.map((item) => ({
      label: item.Acname,
      value: item.Acid,
    })) || [];

  const [filter, setFilter] = useState({
    accountName: [],
  });

  const [search, setSearch] = useState({
    accountName: "",
  });




  useEffect(() => {
    if (!startDate || !endDate) return;
    dispatch(StoreFilters());
    dispatch(PartyVsItemFun());

    dispatch(
      PartyVsItem({
        firm: Firm,
        Acyear: FinancialYear,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  }, [dispatch, endDate, startDate, Firm]);

  const columns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Apr", key: "April", align: "right", format: "true" },
    { label: "May", key: "May", align: "right", format: "true" },
    { label: "Jun", key: "June", align: "right", format: "true" },
    { label: "Jul", key: "July", align: "right", format: "true" },
    { label: "Aug", key: "August", align: "right", format: "true" },
    { label: "Sep", key: "September", align: "right", format: "true" },
    { label: "Oct", key: "October", align: "right", format: "true" },
    { label: "Nov", key: "November", align: "right", format: "true" },
    { label: "Dec", key: "December", align: "right", format: "true" },
    { label: "Jan", key: "January", align: "right", format: "true" },
    { label: "Feb", key: "February", align: "right", format: "true" },
    { label: "Mar", key: "March", align: "right", format: "true" },
    { label: "Net Amount", key: "NetAmount", align: "right", format: "true" },
  ];

  const initialData = (PartyVsItemdata?.PartiWise || []).map((row) => ({
    AcName: row.AcName,
    April: row.AprilAmt,
    May: row.MayAmt,
    June: row.JunAmt,
    July: row.JulyAmt,
    August: row.AugAmt,
    September: row.SepAmt,
    October: row.OctAmt,
    November: row.NovAmt,
    December: row.DecAmt,
    January: row.JanAmt,
    February: row.FebAmt,
    March: row.MarchAmt,
    NetAmount: row.NetAmount,
  }));

  const columns1 = [
    { label: "Sr. No.", key: "srNumber", align: "left" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Apr", key: "April", align: "right", format: "true" },
    { label: "May", key: "May", align: "right", format: "true" },
    { label: "Jun", key: "June", align: "right", format: "true" },
    { label: "Jul", key: "July", align: "right", format: "true" },
    { label: "Aug", key: "August", align: "right", format: "true" },
    { label: "Sep", key: "September", align: "right", format: "true" },
    { label: "Oct", key: "October", align: "right", format: "true" },
    { label: "Nov", key: "November", align: "right", format: "true" },
    { label: "Dec", key: "December", align: "right", format: "true" },
    { label: "Jan", key: "January", align: "right", format: "true" },
    { label: "Feb", key: "February", align: "right", format: "true" },
    { label: "Mar", key: "March", align: "right", format: "true" },
    { label: "Total Qty", key: "TotalQty" },
  ];

  const initialData1 = (PartyVsItemdata?.ItemWise || []).map((row) => ({
    ItemName: row.ItemName,

    April: row.AprilQty,
    May: row.MayQty,
    June: row.JunQty,
    July: row.JulyQty,
    August: row.AugQty,
    September: row.SepQty,
    October: row.OctQty,
    November: row.NovQty,
    December: row.DecQty,
    January: row.JanQty,
    February: row.FebQty,
    March: row.MarchQty,

    TotalQty: row.TotalInwQty,
  }));

  const columns2 = [
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Min Rate", key: "MinInwRate", align: "right", format: "true" },
    { label: "Max Rate", key: "MaxInwRate", align: "right", format: "true" },
    {
      label: "Different Rate",
      key: "DiffRate",
      align: "right",
      format: "true",
    },
  ];

  const initialData2 = (PartyVsItemdata?.MinMaxRate || []).map((row) => ({
    ItemName: row?.ItemName ?? "",
    MonthName: row?.MonthName ?? "",
    MinInwRate: row?.MinRate ?? 0,
    MaxInwRate: row?.MaxRate ?? 0,
    DiffRate: row?.DiffRate ?? 0,
  }));

  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!PartyVsItemdata || PartyVsItemdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }


  const toggleItem = (type, item) => {
    setFilter((prev) => {
      // Account Name => Single Select
      if (type === "accountName") {
        dispatch(PartyVsItemFun());

        dispatch(
          PartyVsItem({
            firm: Firm,
            Acyear: FinancialYear,
            AcIDs: item.value.toString(),
            StartDate: safeFormat(startDate),
            EndDate: safeFormat(endDate),
          })
        );

        return {
          ...prev,
          accountName: [item.value],
        };
      }

      // Multi Select Filters
      const selected = prev[type] || [];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };

    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!PartyVsItemdata || PartyVsItemdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        minHeight: "100vh",
      }}
    >

      <Row>
        {/* 🔷 Mobile Filter Button */}
        <Col xs={12} className="d-lg-none mb-2 text-end">
          <Button
            onClick={() => setShowFilter(true)}
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
              border: "none",
              borderRadius: "10px",
              padding: "8px 12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
            }}
          >
            <FiMenu size={22} />
          </Button>
        </Col>
        {/* 🔷 Offcanvas */}
        <Offcanvas
          show={showFilter}
          onHide={() => setShowFilter(false)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              style={{ color: isdark === "light" ? "#000" : "#fff" }}
            >
              Filters
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <div >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour8
                        : iscolourDark?.Colour11,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    padding: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color: isdark === "light" ? "#000" : "#FFF",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>

              <MaintenanceFilter
                title="Account Name"
                items={accountNameList}
                search={search.accountName}
                setSearch={(val) => handleSearch("accountName", val)}
                selectedItems={filter.accountName}
                toggleItem={(item) => toggleItem("accountName", item)}
                selectAll={() => selectAll("accountName", accountNameList)}
              />
            </div>

          </Offcanvas.Body>
        </Offcanvas>

        {/* 🔷 Desktop Filter */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Date */}
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#FFF",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            {/* Filters */}
            <MaintenanceFilter
              title="Account Name"
              items={accountNameList}
              search={search.accountName}
              setSearch={(val) => handleSearch("accountName", val)}
              selectedItems={filter.accountName}
              toggleItem={(item) => toggleItem("accountName", item)}
              selectAll={() => selectAll("accountName", accountNameList)}
            />
          </div>
        </Col>

        {/* 🔷 Tables */}
        <Col xl={9} lg={8} >
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          {["PARTYWISE", "ITEMWISE", "MIN/MAX RATE"].map((btn) => (
            <button
              key={btn}
              onClick={() => setActiveTable(btn)}
              style={{
                flex: 1,
                fontSize: "14px",
                borderRadius: "12px",
                fontWeight: "bold",
                width: "100%",
                height: "58px",
                cursor: "pointer",
                border: `2px solid ${isdark === "light"
                  ? iscolour?.Colour6
                  : iscolourDark?.Colour11
                  }`,
                background:
                  activeTable === btn
                    ? isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11
                    : isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour2,
                color:
                  activeTable === btn
                    ? isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1
                    : isdark === "light"
                      ? "#000"
                      : "#fff   ",
              }}
            >
              {btn}
            </button>
          ))}
        </div>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            marginTop: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          }}
        >
          {/* 🔹 Heading */}
          <div
            style={{
              padding: "14px",
              background:
                isdark === "light"
                  ? iscolour?.Colour8
                  : iscolourDark?.Colour11,
              color: "#fff",
              fontWeight: "600",
              letterSpacing: "1px",
              fontSize: "18px",
            }}
          >
            {activeTable}
          </div>

          {/* 🔹 Table */}
          {activeTable === "PARTYWISE" && (
            <MaintenanceTable columns={columns} data={initialData} />
          )}

          {activeTable === "ITEMWISE" && (
            <MaintenanceTable columns={columns1} data={initialData1} />
          )}

          {activeTable === "MIN/MAX RATE" && (
            <MaintenanceParentChild
              columns={columns2}
              data={initialData2}
              parentKey="ItemName"
            />
          )}
        </div>
      </Col>


    </Row>
      {
    showDatePicker && (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999,
        }}
        onClick={() => setShowDatePicker(false)}
      >
        <MaintenanceCelender
          isdark={isdark}
          iscolour={iscolour}
          iscolourDark={iscolourDark}
        />
        <div
          style={{
            background:
              isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

            borderRadius: "20px",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Calendar
            className="custom-calendar"
            selectRange={true}
            onChange={(value) => {
              if (Array.isArray(value)) {
                setDateRange([
                  {
                    startDate: value[0],
                    endDate: value[1],
                    key: "selection",
                  },
                ]);
              }
            }}
            value={
              dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                ? [dateRange[0].startDate, dateRange[0].endDate]
                : null
            }
          />

          <div
            className="date-picker-footer"
            style={{
              textAlign: "center",
              marginTop: "15px",
              padding: "12px",
              background:
                isdark === "light"
                  ? iscolour?.Colour3
                  : iscolourDark?.Colour3,
              borderRadius: "0 0 20px 20px",
            }}
          >
            <button
              onClick={() => setShowDatePicker(false)}
              style={{
                padding: "10px",
                borderRadius: "12px",
                border: "none",
                cursor: "pointer",
                fontWeight: "700",
                color: "#fff",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                transition: "0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.opacity = "0.85";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = "1";
                e.target.style.transform = "scale(1)";
              }}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    )
  }
    </div >
  );
};

export default PartyItemAnalysis;
